import { QueryClient } from '@tanstack/react-query';
import { errorStatus, isNetworkError } from '../shared/api';

/**
 * Server state lives here (TanStack Query). Retries only transient failures; 4xx answers
 * are final. Paused mutations resume when the connection returns while the app is open
 * (they are not persisted across reloads).
 */
export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 24 * 60 * 60 * 1000,
        retry: (failureCount, error) => {
          const status = errorStatus(error);
          if (status !== undefined && status < 500) return false;
          if (!navigator.onLine) return false; // offline: show the cached answer or the error now
          return failureCount < 2 || (isNetworkError(error) && failureCount < 3);
        },
        refetchOnWindowFocus: true, // keeps shared lists fresh until realtime (Phase 5)
        // Always try the request: offline, the service worker answers from its cache.
        networkMode: 'offlineFirst',
      },
      mutations: { networkMode: 'online', retry: 0 },
    },
  });
}
